// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"366":"cd0d983f","410":"58163b7d","453":"9451e778","618":"fc58376e"}[chunkId] + ".chunk.js";
};